module.exports = __webpack_public_path__ + "assets/img/coin-rwa-bj-1.c46c22d6.png";